




































import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import OrderModel from "@/models/order/Order";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import AsiTabs from "@/components/common/AsiTabs";
import OrderTabDetails from "@/components/order/OrderTabDetails.vue";
import OrderTabPlanningEntries from "@/components/order/OrderTabPlanningEntries.vue";
import {Permissions} from "@/helpers/constants";
import AsiConfirmDialog from "@/components/common/AsiConfirmDialog.vue";
import AsiMenuItem from "@/components/common/AsiMenuItem.vue";
import OrderTabReports from "@/components/order/OrderTabReports.vue";

@Component({
	components: {
		OrderTabReports,
		AsiConfirmDialog, AsiMenuItem, OrderTabPlanningEntries, OrderTabDetails, AsiPageTitle, AsiTabs
	}
})
export default class Order extends Vue {

	@Prop({type: String, required: true})
	public id!: string;

	private icons = Icon;
	private loading: boolean = false;
	private order: OrderModel | null = null;
	private activeTab: number = 0;

	private get orderName(): string | null {
		return this.order?.name ?? null;
	}

	private get companyName(): string | null {
		return this.order?.company.name ?? null;
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	private get hasReports(): boolean {
		return this.order?.hasReports ?? true;
	}

	public mounted(): void {
		this.loadOrder();
	}

	private loadOrder(): void {
		this.loading = true;
		this.$orderService.order(this.id)
			.then(order => {
				this.order = order;
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => {
				this.loading = false;
			});
	}

	private deleteOrder(): void {
		if (this.order === null || this.order.hasReports) return;

		const confirm = this.$refs.confirm as unknown as AsiConfirmDialog;
		confirm.openDialog().then((res: boolean) => {
			if (!res || this.order === null) return;

			this.loading = true;
			this.$orderService.delete(this.order.id)
				.then(() => {
					this.$router.push({name: 'Orders'})
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.deleteError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => {
					this.loading = false;
				});
		});
	}

}
